import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { Checkbox } from '../Checkbox';

export const CheckboxGroup = ({
  title,
  name,
  fields,
  className,
  titleClassName,
  fieldsClassName,
  checkboxContainerClassName,
  checkboxInputClassName,
  inputClassName,
}) => (
  <div className={className}>
    <div className={titleClassName}>{title}</div>
    <div className={fieldsClassName}>
      {map(fields, (field, index) => (
        <Checkbox
          key={String(index)}
          className={checkboxContainerClassName}
          checkboxInputClassName={checkboxInputClassName}
          inputClassName={inputClassName}
          name={name}
          {...field}
        />
      ))}
    </div>
  </div>
);

CheckboxGroup.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  fields: PropTypes.array,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  fieldsClassName: PropTypes.string,
  checkboxContainerClassName: PropTypes.string,
  checkboxInputClassName: PropTypes.string,
  inputClassName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Form/CheckboxGroup/CheckboxGroup.js